module.exports = __webpack_public_path__ + "img/view3d-notice-2.73748d82.png";